import React from 'react';
import { Card } from 'react-bootstrap';
import SwiperCore, { Autoplay, Pagination } from "swiper";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import '../Service.scss';


SwiperCore.use([Pagination, Autoplay]);

const ServiceCard = ({ services }) => {
  return (
    <Swiper
      breakpoints={{
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      }}
      autoplay={{
        delay: 3000,
      }}
      pagination={{ clickable: true }}
    >
      {services.map((service) => (
        <SwiperSlide className="pb-5" key={service.id}>
          <Card className="h-100 shadow service-card">
            <div className="slider text-center card-body">
              <img src={service.image} alt="" />
              <h5>{service.title}</h5>
              <p>{service.text}</p>
            </div>
          </Card>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ServiceCard;